<template>
  <validation-observer
    v-if="loading"
    ref="formProfileSettings"
  >
    <b-row>
      <b-col
        sm="6"
        lg="4"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Perfil"
          rules="required"
        >
          <!-- Perfil -->
          <b-form-group
            label="Perfil*"
            label-for="profiles"
          >
            <v-select
              id="profiles"
              v-model="getFormData.perfil"
              :options="profiles"
              variant="custom"
              item-text="descricao"
              item-value="id_perfil"
              placeholder="Selecione um perfil"
              label="descricao"
              :disabled="profilesLoading || getDisabledInActionType"
              @input="loadDataByProfile"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <!-- Departamento -->
      <b-col
        v-if="!isAdminCompany"
        sm="6"
        lg="4"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Departamento regional"
          rules="required"
        >
          <b-form-group
            label="Departamento regional*"
            label-for="departments"
          >
            <v-select
              id="departments"
              v-model="getFormData.departamento"
              :options="departments"
              variant="custom"
              item-text="descricao"
              item-value="id_departamento"
              placeholder="Selecione um departamento"
              label="descricao"
              :disabled="departmentsDisable"
              @input="loadDataByDepartment"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <!-- Regiões -->
      <b-col
        v-if="getUoProfileMode"
        sm="6"
        lg="4"
        class="mb-2"
      >
        <b-form-group
          label="Regiões relacionadas*"
          label-for="regions"
        >
          <v-select
            id="regions"
            v-model="getFormData.regioes"
            v-b-tooltip.hover.top="!getFormData.departamento ? 'Selecione um Departamento.' : ''"
            :options="regions"
            variant="custom"
            :reduce="region => region"
            label="descricao"
            :placeholder="definePlaceholderRegionsSelect"
            :disabled="regionsDisable"
            :multiple="getRegionsProfile"
            @input="loadDataByRegion"
          >
            <template
              v-slot:no-options
            >
              Nenhum registro encontrado.
            </template>
          </v-select>
        </b-form-group>
      </b-col>

      <!-- Unidades -->
      <b-col
        v-if="getFormData.regioes && showUnitsSelect"
        sm="6"
        lg="4"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Unidades"
          rules="required"
        >
          <b-form-group
            label="Unidade*"
            label-for="units"
          >
            <v-select
              id="units"
              v-model="chosenUnit"
              :options="units"
              variant="custom"
              item-text="descricao"
              item-value="id_unidade"
              placeholder="Selecione uma unidade"
              label="descricao"
              @input="chooseUnit()"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <!-- Unidades Checkbox -->
      <b-col
        v-if="getFormData.regioes && showManyUnitsCheck"
        cols="12"
        class="mb-2"
      >
        <div class="d-flex button-container">
          <button
              type="button"
              class="btn custom-blue button-custom-size mr-1 mb-1"
              @click="selectAllUnits"
          >
            <feather-icon icon="CheckIcon" /> Selecionar Todas
          </button>

          <button
              type="button"
              class="btn btn-outline-dropbox button-custom-size mb-1"
              @click="clearAllUnits"
          >
            <feather-icon icon="CheckIcon" /> Limpar Seleção
          </button>
        </div>

        <div class="d-flex flex-wrap">
          <div
            v-for="(region, i) in getFormData.regioes"
            :key="i"
            class="card-units"
          >
            <b-form-group
              label-class="font_size_label"
              :label="region.descricao"
              class="d-flex"
            >
              <b-form-checkbox
                  :checked="isAllSelected(region)"
                  @change="toggleSelectAll(region)"
                  class="mb-2"
              >
                <strong>Selecionar Todas</strong>
              </b-form-checkbox>
              <hr />

              <small v-if="getUnitsArray(region).length === 0">
                Nenhum registro encontrado.
              </small>

              <b-form-checkbox-group
                id="checkbox-units"
                v-model="getFormData.unidades"
                name="checkbox-units"
              >
                <b-form-checkbox
                  v-for="(unit, j) in getUnitsArray(region)"
                  :key="j"
                  :value="unit.id_unidade"
                >
                  {{ unit.descricao }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="canByNationalBaseRule && !isAdminCompany"
    >
      <b-col
        sm="6"
        lg="4"
      >
        <b-form-group
          label="Atua com Empresas de Base Nacional ? *"
          label-for="nationalBaseOption"
        >
          <b-form-radio-group
            v-model="nationalBaseOption"
            v-b-tooltip.hover.top="getNationalBaseMessageInfo"
            :options="nationalBaseRadioOptions"
            class="demo-inline-spacing mb-1"
            value-field="value"
            text-field="text"
            :disabled="nationalBaseOptionsDisable || getDisabledInActionType"
          />
        </b-form-group>
      </b-col>

      <b-col
        v-if="nationalBaseOption"
        sm="6"
        lg="4"
        class="mb-2"
      >
        <b-form-group
          label="Tipo de atuação*"
          label-for="nationalBaseActivityType"
        >
          <validation-provider
            #default="{ errors }"
            name="Tipo de atuação"
            :rules="nationalBaseOption ? 'required' : ''"
          >
            <v-select
              id="nationalBaseActivityType"
              v-model="getFormData.tipoAtuacao"
              :options="nationalBaseActivityTypes"
              variant="custom"
              item-text="descricao"
              item-value="id_tipo_atuacao"
              placeholder="Selecione uma opção"
              label="descricao"
              @input="() => {
                if(canEditPermiteGerenciarAdesao){
                  getFormData.permiteGerenciarAdesao = false
                }
              }"
              :disabled="nationalBaseOptionsDisable || getDisabledInActionType"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Pode cancelar/criar adesões?*"
          label-for="nationalBaseOption"
          v-if="getFormData.tipoAtuacao && getFormData.tipoAtuacao.chave === chaveTipoAtuacao.OPERADOR"
        >
          <b-form-radio-group
            v-model="getFormData.permiteGerenciarAdesao"
            :options="permiteEstornarVacinacaoRadioOption"
            class="demo-inline-spacing mb-1"
            value-field="value"
            text-field="text"
            :disabled="!canEditPermiteGerenciarAdesao"
          />
        </b-form-group>
        
      </b-col>
    </b-row>

    <!-- Campos para vacinadores -->
    <b-row>
      <b-col
        sm="6"
        lg="4"
      >
        <b-form-group
          label="Vacinador ? *"
          label-for="vacinadorOption"
        >
          <b-form-radio-group
            v-model="getFormData.vacinadorOption"
            :options="vacinadorRadioOptions"
            class="demo-inline-spacing mb-1"
            value-field="value"
            text-field="text"
            :disabled="vacinadorOptionsDisable || getDisabledInActionType"
            @change="actionOptionVacinador"            
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="getFormData.vacinadorOption">
      <b-col
        sm="6"
        lg="3"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Sigla do Conselho de Classe"
          rules="required"
        >
          <!-- Sigla do Conselho de Classe -->
          <b-form-group
            label="Sigla do Conselho de Classe*"
            label-for="tipoDocumento"
          >
            <v-select
              id="tipoDocumento"
              v-model="getFormData.tipoDocumento"
              :options="tipoDocumento"
              variant="custom"
              item-text="sigla"
              item-value="id_tipo_documento"
              placeholder="Selecione um conselho de classe"
              label="sigla"
              :disabled="tipoDocumentoLoading || getDisabledInActionType"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col
        sm="6"
        lg="3"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Número do Conselho de Classe"
          rules="required"
        >
          <!-- Número do Conselho de Classe -->
          <b-form-group
            label="Número do Conselho de Classe*"
            label-for="numeroDocumento"
          >
            <b-form-input
              id="numeroDocumento"
              v-model="getFormData.numeroDocumento"
              type="text"
              autocomplete="off"
              placeholder="Número do Conselho de Classe"        
              maxlength="10" 
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col
        sm="6"
        lg="3"
        class="mb-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Estado"
          rules="required"
        >
          <!-- Estado -->
          <b-form-group
            label="Estado*"
            label-for="estadoDocumento"
          >
            <v-select
              id="estadoDocumento"
              v-model="getFormData.estadoDocumento"
              :options="estadoDocumento"
              variant="custom"
              item-text="uf"
              item-value="uf"
              placeholder="Selecione um Estado"
              label="uf"
              :disabled="estadoDocumentoLoading || getDisabledInActionType"
            >
              <template
                v-slot:no-options
              >
                Nenhum registro encontrado.
              </template>
            </v-select>

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>

      <b-col
          sm="6"
          lg="3"
          class="mb-2"
      >
        <validation-provider
            #default="{ errors }"
            name="CNS"
            rules="length:15"
            :custom-messages="{length: 'O campo CNS deve ter 15 caracteres numéricos'}"
        >
          <!-- Número do Cadastro Nacional de Saúde -->
          <b-form-group
              label="CNS"
              label-for="cns"
          >
            <b-form-input
                id="cns"
                v-model="getFormData.cns"
                type="text"
                autocomplete="off"
                v-mask="'###############'"
                placeholder="CNS"
                maxlength="15"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>

    <b-row v-if="isDnProfile">
      <b-col
          sm="6"
          lg="4"
      >
        <b-form-group
            label="Receber Notificações de Falha na API-CNPJ?"
            label-for="permiteNotificacaoApiCnpjOption"
        >
          <b-form-radio-group
              v-model="getFormData.permiteNotificacaoApiCnpjOption"
              :options="permiteNotificacaoApiCnpjRadioOptions"
              class="demo-inline-spacing mb-1"
              value-field="value"
              text-field="text"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="canShowCancelVacinados && canCancelVacinados">
      <b-col
        sm="6"
        lg="4"
      >
        <b-form-group
          label="Cancelar Vacinados ? *"
          label-for="permiteEstornarVacinacaoOption"
        >
          <b-form-radio-group
            v-model="getFormData.permiteEstornarVacinacaoOption"
            :options="permiteEstornarVacinacaoRadioOption"
            class="demo-inline-spacing mb-1"
            value-field="value"
            text-field="text"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>

import {
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup, BFormRadioGroup,
  BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  getDepartments, getNationalBaseActivityTypes,
  getProfiles,
  getRegions,
  getTipoDocumentos,
} from '@/views/custom-pages/gerenciarUsuarios/requests'
import chavePerfil from '@/enum/chavePerfil'
import chaveTipoAtuacao from '@/enum/chaveTipoAtuacao';
import { actions, subjects } from '@/libs/acl/rules'

export default {
  components: {
    BFormRadioGroup,
    ValidationObserver,
    ValidationProvider,
    BFormCheckboxGroup,
    BFormCheckbox,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  props: {
    className: {
      type: String,
      default: '',
    },

    mode: {
      type: String,
      default: 'insert',
    },
  },

  data() {
    return {
      chavePerfil,
      chaveTipoAtuacao,
      departmentsDisable: true,
      profilesLoading: true,
      regionsDisable: true,
      unitsDisable: true,
      tipoDocumentoLoading: false,
      estadoDocumentoLoading: false,

      showRegionsSelect: false,
      showUnitsSelect: false,
      showManyUnitsCheck: false,

      profiles: [],
      departments: [],
      regions: [],
      units: [],
      tipoDocumento: [],
      estadoDocumento: [],

      chosenUnit: null,

      loading: true,

      nationalBaseOption: false,

      nationalBaseOptionsDisable: true,

      nationalBaseRadioOptions: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
      
      nationalBaseActivityTypes: [],
      
      vacinadorOptionsDisable: false,
      vacinadorRadioOptions: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],

      permiteEstornarVacinacaoRadioOption: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],

      permiteNotificacaoApiCnpjRadioOptions: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
    }
  },

  computed: {
    getMode() {
      return this.mode
    },

    getFormData() {
      return this.$store.getters['adminUserState/getFormData']
    },

    getProfileInFormData() {
      return this.getFormData.perfil
    },

    getDepartmentsInFormData() {
      return this.getFormData.departamento
    },

    getRegionsInFormData() {
      return this.getFormData.regioes
    },

    getProfileKey() {
      return this.getFormData.perfil ? this.getFormData.perfil.chave : null
    },

    getDnProfilesMode() {
      return [
        chavePerfil.ADMIN_DN,
        chavePerfil.SAUDE_DN,
        chavePerfil.MERCADO_DN,
      ].includes(this.getProfileKey)
    },

    getDnDrProfilesMode() {
      return [
        chavePerfil.ADMIN_DN,
        chavePerfil.SAUDE_DN,
        chavePerfil.MERCADO_DN,
        chavePerfil.ADMIN_DR,
        chavePerfil.SAUDE_DR,
        chavePerfil.MERCADO_DR,
        chavePerfil.MASTER,
      ].includes(this.getProfileKey)
    },

    getUoProfileMode() {
      return [
        chavePerfil.SAUDE_REGIAO,
        chavePerfil.ADMIN_UNIDADE,
        chavePerfil.VACINADOR_PADRAO,
        chavePerfil.VACINADOR_ADMIN,
        chavePerfil.SAUDE_UO,
      ].includes(this.getProfileKey)
    },

    getRegionsProfile() {
      return [
        chavePerfil.SAUDE_REGIAO,
        chavePerfil.VACINADOR_PADRAO,
        chavePerfil.VACINADOR_ADMIN,
        chavePerfil.SAUDE_UO,
      ].includes(this.getProfileKey)
    },

    getUnitProfile() {
      return this.getProfileKey === chavePerfil.ADMIN_UNIDADE
    },

    isAdminCompany() {
      return this.getProfileKey === chavePerfil.ADMIN_EMPRESA
    },

    definePlaceholderRegionsSelect() {
      if (this.getRegionsProfile) {
        return 'Selecione uma ou mais'
      }

      return 'Selecione uma região'
    },

    canByNationalBaseRule() {
      return this.$can(actions.VISUALIZAR, subjects.ATUACAO_BASE_NACIONAL)
    },

    canShowCancelVacinados() {
      return this.$can(actions.VISUALIZAR, subjects.CANCELAR_VACINADOS)
    },

    canEditPermiteGerenciarAdesao(){
      return this.$can(actions.VISUALIZAR, subjects.TIPO_ATUACAO_BASE_NACIONAL_COORDENADOR)
    },
    canCancelVacinados(){
      return [
        chavePerfil.SAUDE_DR,
        chavePerfil.SAUDE_REGIAO,
        chavePerfil.SAUDE_UO,
        chavePerfil.VACINADOR_PADRAO,
        chavePerfil.VACINADOR_ADMIN
      ].includes(this.getProfileKey)
    },

    getNationalBaseMessageInfo() {
      if (!this.getFormData.perfil) {
        return 'Selecione um perfil.'
      }

      if (!this.getDnDrProfilesMode) {
        return 'O perfil selecionado não atua como base nacional.'
      }

      return ''
    },

    getActionTypeCoordinatorView() {
      return this.$can(actions.VISUALIZAR, subjects.TIPO_ATUACAO_BASE_NACIONAL_COORDENADOR)
    },

    getActionTypeOperatorView() {
      return this.$can(actions.VISUALIZAR, subjects.TIPO_ATUACAO_BASE_NACIONAL_OPERADOR)
    },

    getDisabledInActionType() {
      if (this.getFormData.tipoAtuacao && this.getMode === 'update') {
        return this.getActionTypeOperatorView && this.getFormData.tipoAtuacao.chave === 'COORDENADOR'
      }

      return false
    },

    isDnProfile() {
      return [
        chavePerfil.ADMIN_DN,
        chavePerfil.SAUDE_DN,
      ].includes(this.getProfileKey);
    },
  },

  watch: {
    getProfileInFormData(value) {
      if (!value) {
        this.getFormData.departamento = null
        this.getFormData.regioes = []
        this.getFormData.unidades = []
        this.units = []
        this.chosenUnit = null

        this.regionsDisable = true
        this.showManyUnitsCheck = false
        this.showUnitsSelect = false
      }
    },

    getDepartmentsInFormData(value) {
      if (!value) {
        this.getFormData.regioes = []
        this.getFormData.unidades = []
        this.units = []
        this.chosenUnit = null

        this.regionsDisable = true
        this.showManyUnitsCheck = false
        this.showUnitsSelect = false
      }
    },

    getRegionsInFormData(value) {
      if (!value) {
        this.getFormData.unidades = []
        this.units = []
        this.chosenUnit = null

        this.showManyUnitsCheck = false
        this.showUnitsSelect = false
      }
    },

    nationalBaseOption(value) {
      if (!value) {
        this.getFormData.tipoAtuacao = null
      }
    },
  },

  mounted() {
    this.index()
  },

  methods: {
    async index() {
      await this.handleGetProfiles()
      await this.handleGetDepartments()
      await this.handleGetSiglaConselho()
      await this.handleGetEstados()

      if (this.canByNationalBaseRule) {
        await this.handleGetNationalBaseActivityTypes()
      }

      if (this.getMode === 'update') {
        if (this.getFormData.regioes) {
          await this.loadDataByDepartment()
          await this.loadDataByRegionInUpdate()
        }

        if (this.canByNationalBaseRule && this.getDnDrProfilesMode) {
          this.nationalBaseOptionsDisable = false
        }

        this.nationalBaseOption = !!(this.getFormData.tipoAtuacao && this.canByNationalBaseRule && this.getDnDrProfilesMode)

        if (this.getDnProfilesMode) {
          this.nationalBaseOptionsDisable = true
          this.nationalBaseOption = true
          this.departmentsDisable = true
        }
      }
    },

    loadDataByProfile() {
      if (this.getProfileKey === chavePerfil.ADMIN_EMPRESA) {
        this.getFormData.departamento = this.getFormData.departamentoAux
      } else {
        this.getFormData.departamento = null
      }

      this.getFormData.regioes = []
      this.getFormData.unidades = []
      this.units = []
      this.chosenUnit = null

      this.departmentsDisable = false
      this.regionsDisable = true
      this.showManyUnitsCheck = false
      this.showUnitsSelect = false

      this.nationalBaseOptionsDisable = true
      this.nationalBaseOption = false

      this.handleDnDrProfilesConfig()
      this.handleDnProfilesConfig()
    },

    handleDnDrProfilesConfig() {
      if (this.getDnDrProfilesMode) {
        this.nationalBaseOptionsDisable = false
      }
    },

    handleDnProfilesConfig() {
      if (this.getDnProfilesMode) {
        this.nationalBaseOptionsDisable = true
        this.departmentsDisable = true
        this.nationalBaseOption = true

        this.getFormData.departamento = {
          id_departamento: 1,
          descricao: 'Departamento Nacional',
        }

        this.getFormData.tipoAtuacao = this.nationalBaseActivityTypes.filter(item => item.chave === 'COORDENADOR')
      }
    },

    async loadDataByDepartment() {
      if (this.getUoProfileMode) {
        await this.handleGetRegions()
      }
    },

    loadDataByRegion() {
      this.units = []
      this.chosenUnit = null
      this.showManyUnitsCheck = false
      this.showUnitsSelect = false
      
      if (Array.isArray(this.getFormData.regioes)) {
        this.showManyUnitsCheck = true
        const selectedRegionIds = this.getFormData.regioes.map(r => r.id_regiao)
        const validUnits = this.regions
          .filter(region => selectedRegionIds.includes(region.id_regiao))
          .flatMap(region => 
            Array.isArray(region.unidade) ? region.unidade : 
            (region.unidade ? Object.values(region.unidade) : [])
          )
        
        const validUnitIds = validUnits.map(unit => unit.id_unidade)
        this.getFormData.unidades = this.getFormData.unidades.filter(unitId => 
          validUnitIds.includes(unitId)
        )
        return
      }
      
      if (!this.getFormData.regioes) return
      
      const fullRegion = this.regions.find(r => r.id_regiao === this.getFormData.regioes.id_regiao)
      if (!fullRegion) return
      
      const regionUnits = Array.isArray(fullRegion.unidade) ? fullRegion.unidade : 
        (fullRegion.unidade ? Object.values(fullRegion.unidade) : [])
      
      if (regionUnits.length > 0) {
        this.units = regionUnits
        this.showUnitsSelect = true
      }
    },

    loadDataByRegionInUpdate() {
      if (this.getRegionsProfile) {
        this.showManyUnitsCheck = true
      
        if (Array.isArray(this.getFormData.regioes)) {
          this.getFormData.regioes = this.getFormData.regioes.map(selectedRegion => {
            return this.regions.find(r => r.id_regiao === selectedRegion.id_regiao) || selectedRegion
          })
        }
      }

      if (!this.getUnitProfile) return
      if (this.getFormData.regioes.length === 0) return
      
      this.getFormData.regioes.forEach(selectedRegion => {
        const fullRegion = this.regions.find(r => r.id_regiao === selectedRegion.id_regiao)
        if (fullRegion) {
          const regionUnits = Array.isArray(fullRegion.unidade) ? fullRegion.unidade : 
            (fullRegion.unidade ? Object.values(fullRegion.unidade) : [])
          
          regionUnits.forEach(unit => {
            this.units.push(unit)
          })
        }
      })

      this.chosenUnit = this.getFormData.unidades
      this.showUnitsSelect = true
    },

    async handleGetProfiles() {
      this.setLoading(true)
      this.profilesLoading = true

      await getProfiles()
        .then(response => {
          const { data } = response

          if (this.getMode === 'insert') {
            this.profiles = data.filter(item => (item.id_tipo_perfil === 1) || (item.id_tipo_perfil === 2))
          } else {
            this.profiles = data
          }
        })

      this.profilesLoading = false
      this.setLoading(false)
    },

    async handleGetSiglaConselho() {
      this.setLoading(true)
      this.tipoDocumentoLoading = true

      await getTipoDocumentos()
        .then(response => {
          const { data } = response

          this.tipoDocumento = data
        })

      this.tipoDocumentoLoading = false
      this.setLoading(false)
    },

    async handleGetEstados() {
      this.setLoading(true);
      this.estadoDocumentoLoading = true;

      await this.$http.get(this.$api.getEstados()).then(({ data }) => {          
        this.estadoDocumento = data;
      });
      
      this.estadoDocumentoLoading = false;
      this.setLoading(false);
    },

    async handleGetDepartments() {
      this.setLoading(true)
      this.departmentsDisable = true

      await getDepartments()
        .then(response => {
          const { data } = response

          this.departments = data
        })

      this.departmentsDisable = false
      this.setLoading(false)
    },

    async handleGetRegions() {
      this.setLoading(true)
      this.regionsDisable = true

      if (this.getFormData.departamento) {
        const params = {
          ativo: true,
          id_departamento: this.getFormData.departamento.id_departamento,
        }

        await getRegions(params)
          .then(response => {
            const { data } = response

            this.regions = data
          })
      }

      this.regionsDisable = false
      this.setLoading(false)
    },

    async handleGetNationalBaseActivityTypes() {
      this.setLoading(true)

      await getNationalBaseActivityTypes()
        .then(response => {
          this.nationalBaseActivityTypes = response.data
        })

      this.setLoading(false)
    },

    clear() {
      this.nationalBaseOption = false
      this.nationalBaseOptionsDisable = true
    },

    chooseUnit() {
      this.getFormData.unidades = this.chosenUnit ? [this.chosenUnit.id_unidade] : []
    },

    setLoading(loading) {
      this.$emit('setLoading', loading)
    },

    actionOptionVacinador() {
      if(!this.getFormData.vacinadorOption) {
        this.clearOptionsDocumentoVacinador();
      }
    },

    clearOptionsDocumentoVacinador() {
      this.getFormData.tipoDocumento = null;
      this.getFormData.numeroDocumento = null;
      this.getFormData.estadoDocumento = null;
      this.getFormData.cns = null;
    },

    getUnitsArray(region) {
      const fullRegion = this.regions.find(r => r.id_regiao === region.id_regiao)
      if (!fullRegion || !fullRegion.unidade) return []
      return Array.isArray(fullRegion.unidade) ? fullRegion.unidade : Object.values(fullRegion.unidade)
    },

    selectAllUnits() {
      if (!Array.isArray(this.getFormData.regioes)) return;

      const allUnitIds = this.getFormData.regioes.flatMap(selectedRegion => {
        const fullRegion = this.regions.find(r => r.id_regiao === selectedRegion.id_regiao)
        if (!fullRegion || !fullRegion.unidade) return []
        
        const units = Array.isArray(fullRegion.unidade) ? fullRegion.unidade : Object.values(fullRegion.unidade)
        return units.map(unit => unit.id_unidade)
      });

      this.getFormData.unidades = Array.from(new Set(allUnitIds));
    },

    clearAllUnits() {
      this.getFormData.unidades = [];
    },
    isAllSelected(region) {

      const fullRegion = this.regions.find(r => r.id_regiao === region.id_regiao)
      if (!fullRegion || !fullRegion.unidade) return false
      
      const units = Array.isArray(fullRegion.unidade) ? fullRegion.unidade : Object.values(fullRegion.unidade)
      if (units.length === 0) return false;

      return units.every(unit =>
          this.getFormData.unidades.includes(unit.id_unidade)
      );
    },

    toggleSelectAll(region) {

      const fullRegion = this.regions.find(r => r.id_regiao === region.id_regiao)
      if (!fullRegion || !fullRegion.unidade) return
      
      const units = Array.isArray(fullRegion.unidade) ? fullRegion.unidade : Object.values(fullRegion.unidade)
      if (units.length === 0) return;
      
      const unitIds = units.map(unit => unit.id_unidade);
      const selectedSet = new Set(this.getFormData.unidades);
      const allSelected = unitIds.every(id => selectedSet.has(id));

      if (allSelected) {
        this.getFormData.unidades = this.getFormData.unidades.filter(
            id => !unitIds.includes(id)
        );
        return
      }
      
      const newSelection = [...selectedSet];
      unitIds.forEach(id => {
        if (!selectedSet.has(id)) {
          newSelection.push(id);
        }
      });
      this.getFormData.unidades = newSelection;
    }
  },
}
</script>

<style scoped lang="scss">
.card-units {
  width: 200px;
  background-color: #e5f0f9;
  padding: 1rem;
  margin-bottom: 1.15rem;
  margin-right: 1rem;
  border-radius: 0.357rem;
}

@media(width < 300px) {
  .card-units {
    width: auto;
    margin-right: 0;
  }
}

@media (max-width: 320px) {
  .button-container {
    flex-direction: column !important;
    align-items: stretch;
  }

  .button-container button {
    width: 100%;
  }
}
</style>
